import React, { useState } from "react";

const FAQSection = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  // const faqs = [
  //   {
  //     question: "Is Pixell an online platform?",
  //     answer: "Yes Pixell is an online platform.",
  //   },
  //   {
  //     question: "How does Pixell Work?",
  //     answer:
  //       "Once on the platform a brand can upload a simple document stating the brief about the requirements. Our dedicated team will speak to you and understand the requirements in detail. After this step you just have to sit back and relax. All other operational tasks will be handled by Pixell Team.",
  //   },
  //   {
  //     question:
  //       "How will, Pixell platform help me improve efficiency of my campaigns?",
  //     answer:
  //       "Our state of art application empowers brands with automated workflows, which saves a lot of time in case of repetitive work. It also offers consistent, accurate, and real-time visibility of the campaigns with better decision-making.",
  //   },
  //   {
  //     question: "Is my data secure?",
  //     answer:
  //       "Yes, your data is absolutely safe. We believe that trust is paramount in a relationship. We do not own or sell your data. We also don't pass your data to third party applications without your permission. Your data rests in our database in a completely secure and encrypted form that leaves no scope of data pilferage.",
  //   },
  //   {
  //     question: "How can I get updates about the development of my campaign?",
  //     answer:
  //       "Yes you can get near to real time updates on your dashboards. Get microscope level updates on the campaign at the site level at any point of time.",
  //   },

  // ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className=" py-12 my-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto text-center mb-12">
          {/* Header */}
          {/* <h3 className="text-md uppercase tracking-widest text-gray-500 mb-2">
            KNOW MORE ABOUT US
          </h3> */}
          <h2 className="text-xl md:text-4xl font-bold">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4 xl:max-w-5xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="border rounded-lg bg-white shadow-sm">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full text-left px-4 py-3 flex items-center justify-between"
              >
                <span className="text-gray-800 font-medium">
                  {faq.question}
                </span>
                <span
                  className={`transform transition-transform duration-200 ${
                    openIndex === index ? "rotate-45" : "rotate-0"
                  } text-blue-500 font-bold text-2xl`}
                >
                  +
                </span>
              </button>
              {openIndex === index && (
                <div className="px-4 py-3 text-gray-600">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
